import * as React from "react";
import { cn } from "@/lib/utils";
import { AlertCircle } from "lucide-react";
interface DisclaimerNoticeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: "default" | "compact";
}
const DisclaimerNotice = React.forwardRef<HTMLDivElement, DisclaimerNoticeProps>(({
  className,
  variant = "default",
  ...props
}, ref) => <div ref={ref} className={cn("space-y-4", variant === "compact" ? "text-sm" : "", className)} {...props}>
      {/* Wichtiger Hinweis */}
      <div className="p-6 bg-amber-500/10 border-2 border-amber-500/30 rounded-lg">
        <div className="flex items-start gap-3">
          <AlertCircle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
          <div>
            <h3 className="font-semibold text-foreground mb-2">Wichtiger Hinweis:</h3>
            <p className="text-muted-foreground leading-relaxed">Dieser Service dient als unterstützendes Instrument bei der Erstellung und Überprüfung rechtskonformer Speisen- und Getränkekarten und stellt keine juristische Rechtsberatung dar. Die letztendliche Verantwortung verbleibt unabhängig davon gemäß Art. 17 Abs. 1 der Verordnung (EG) Nr. 178/2002 beim Lebensmittelunternehmer/Inverkehrbringer. </p>
          </div>
        </div>
      </div>
    </div>);
DisclaimerNotice.displayName = "DisclaimerNotice";
export { DisclaimerNotice };